module.exports = __webpack_public_path__ + "img/jbt7118_yvf2_90s.prt.83e7c96e.jpg";